import { Box, Container, Typography } from "@mui/material";
import React from "react";

const Copyright = () => {
  return (
    <Box
      sx={{
        width: "100vw",
        height: "10vh",
        backgroundColor: "secondary.main",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          height: "inherit",
        }}
      >
        <Typography variant="body2" color="#A5A49A">
          © All Copyright 2024{" "}
        </Typography>
        <Typography variant="body2" color="#A5A49A">
          Terms of Use | Private Policy
        </Typography>
      </Container>
    </Box>
  );
};

export default Copyright;
